import React, { useState } from 'react';
import Chart from "react-apexcharts";
import CountUp from 'react-countup';

import { Link } from 'react-router-dom';
import { CardData } from './Components/CreditCardsData'
import { CardExpenseChart } from './Components/CardExpenseChart';
import { CardListData } from './Components/CardListData';
import { CardSettingData } from './Components/CardSetting';

const CreditCards = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {/* // x---------------------------------x  Credit-Card My Cards Section // x---------------------------------x  */}
            <div className="flex flex-row justify-between items-center px-4">
                <h3 className="text-dark text-lg sm:text-2xl font-semibold mb-0">My Cards</h3>
                <Link to="/" className="text-primary text-end text-base font-semibold sm:hidden">See All</Link>
            </div>

            {/* // x---------------------------------x My Cards Section // x---------------------------------x  */}
            <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-4 py-4">
                {CardData.map((cardData, index) => (
                    <div key={index}>
                        <div className={`${cardData.theme ? cardData.bg_color : "card-body"} rounded-2xl shadow-md overflow-hidden`}>
                            <div className="mb-3">
                                <div className={`p-4 ${cardData.text_color}`}>
                                    <div className="flex justify-between items-center">
                                        <div>
                                            <h5 className="text-base sm:text-lg font-normal">Balance</h5>
                                            <h4 className={`text-2xl font-bold ${cardData.text_color}`}>
                                                $ <CountUp
                                                    end={cardData.value}
                                                    duration={2}
                                                />
                                            </h4>

                                        </div>
                                        <div className="card-img" aria-label="Card Icon">{cardData.cardIcon}</div>
                                    </div>
                                    <div className="flex justify-between items-center py-4 sm:py-5">
                                        <div>
                                            <h5 className="text-base sm:text-lg font-normal mb-1">CARD HOLDER</h5>
                                            <h4 className={`text-2xl font-bold ${cardData.text_color}`}>{cardData.name}</h4>
                                        </div>
                                        <div>
                                            <h5 className="text-base sm:text-lg font-normal mb-1">VALID THRU</h5>
                                            <h4 className={`text-2xl font-bold ${cardData.text_color}`}>{cardData.expiry}</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className={`border-t border-dashed ${cardData.borderColor} px-4 sm:px-6 mt-5`}>
                                    <div className="flex justify-between items-center py-2 sm:py-3">
                                        <div>
                                            <h4 className={`text-2xl lg:text-3xl font-bold ${cardData.text_color}`}>{cardData.cardNumber}</h4>
                                        </div>
                                        <div aria-label="Secondary Icon">{cardData.f_icon}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* // x---------------------------------x Card Expense / Card List Section // x---------------------------------x  */}
            <div className="grid my-2 grid-cols-1 xl:grid-cols-12 gap-4">
                {/* // x---------------------------------x Card Expense Statistics // x---------------------------------x  */}
                <div className="xl:col-span-4">
                    <div className="border-0 bg-transparent h-full">
                        <div className="flex justify-between p-3">
                            <h3 className="text-dark text-lg sm:text-2xl font-semibold">Card Expense Statistics</h3>
                        </div>
                        <div className="rounded-2xl mb-3 md:mb-0 card-body flex items-center p-5">
                            <div className="w-full text-dark" id="chart-pipe">
                                <Chart
                                    options={CardExpenseChart}
                                    series={CardExpenseChart.series}
                                    type={CardExpenseChart.chart.type}
                                    height={CardExpenseChart.chart.height}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* // x---------------------------------x Card List // x---------------------------------x  */}
                <div className="xl:col-span-8">
                    <div className="border-0 bg-transparent">
                        <div className="flex justify-between items-center p-3">
                            <h3 className="text-dark text-lg sm:text-2xl font-semibold">Card List</h3>
                            <Link
                                to="/"
                                className="text-dark text-end text-lg sm:text-2xl font-semibold hidden sm:block"
                            >
                                See all
                            </Link>
                        </div>
                        <div className="p-4 rounded-2xl card-body">
                            <ul className="grid gap-4 list-none mb-2" id="MyClients">
                                {CardListData.map((data, index) => (
                                    <li className="w-full" key={index}>
                                        <div className="bg-card mt-1">
                                            <div className="flex flex-col lg:flex-row items-start lg:items-center bg-body rounded-2xl p-4">
                                                {/* x---------------------------------x Avatar and Card Type x---------------------------------x */}
                                                <div className="w-full lg:w-3/12 flex items-center mb-4 lg:mb-0 gap-4 text-dark">
                                                    <div className={`card-img w-14 h-14 rounded-xl flex items-center justify-center ${data.icon_bg}`}>
                                                        {data.icon}
                                                    </div>
                                                    <div>
                                                        <h6 className="text-base font-semibold mb-1">Card Type</h6>
                                                        <span className="text-dark opacity-55 text-sm">{data.cardType}</span>
                                                    </div>
                                                </div>

                                                {/* x---------------------------------x Bank, Card Number, Owner Name, and View Details x---------------------------------x */}
                                                <div className="w-full lg:w-8/12">
                                                    <ul className="flex flex-col sm:flex-row gap-3 sm:gap-6 justify-between items-start sm:items-center mb-0 text-dark">
                                                        <li>
                                                            <div>
                                                                <h6 className="text-base font-semibold mb-1">Bank</h6>
                                                                <span className="text-dark opacity-55 text-sm">{data.BankName}</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div>
                                                                <h6 className="text-base font-semibold mb-1">Card Number</h6>
                                                                <span className="text-dark opacity-55 text-sm">{data.CardNumber}</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div>
                                                                <h6 className="text-base font-semibold mb-1">Name on Card</h6>
                                                                <span className="text-dark opacity-55 text-sm">{data.CardOwnerName}</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <button
                                                                onClick={() => setIsOpen(true)}
                                                                className="text-primary-700 text-sm font-semibold transition duration-200 ease-in-out hover:text-primary-900"
                                                            >
                                                                View Details
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* // x---------------------------------x Add New Card / Card Setting Section // x---------------------------------x  */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                {/* // x---------------------------------x Add New Card // x---------------------------------x  */}
                <div className="lg:col-span-8">
                    <div className="h-full bg-transparent border-0">
                        <div className="flex justify-between p-3">
                            <h3 className="text-dark text-lg sm:text-2xl font-semibold">Add New Card</h3>
                        </div>
                        <div className="card-body rounded-lg mb-3 sm:mb-0 bg-white p-6">
                            <div>
                                <p className="opacity-75 text-base font-normal m-0 text-dark">
                                    Credit Card generally means a plastic card issued by Scheduled Commercial Banks assigned to a Cardholder,
                                    with a credit limit, that can be used to purchase goods and services on credit or obtain cash advances.
                                </p>
                            </div>
                            <form>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3 text-dark">
                                    {/* Card Type */}
                                    <div>
                                        <label htmlFor="card-type" className="form-label text-sm font-medium">
                                            Card Type
                                        </label>
                                        <input
                                            type="text"
                                            className="bg-light rounded-lg py-3 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                                            id="card-type"
                                            placeholder="Classic"
                                        />
                                    </div>
                                    {/* Name on Card */}
                                    <div>
                                        <label htmlFor="name-on-card" className="form-label text-sm font-medium">
                                            Name On Card
                                        </label>
                                        <input
                                            type="text"
                                            className="bg-light rounded-lg py-3 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                                            id="name-on-card"
                                            placeholder="My Cards"
                                        />
                                    </div>
                                    {/* Card Number */}
                                    <div>
                                        <label htmlFor="card-number" className="form-label text-sm font-medium">
                                            Card Number
                                        </label>
                                        <input
                                            type="text"
                                            className="bg-light rounded-lg py-3 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                                            id="card-number"
                                            placeholder="**** **** **** ****"
                                        />
                                    </div>
                                    {/* Expiration Date */}
                                    <div>
                                        <label htmlFor="expiration-date" className="form-label text-sm font-medium ">
                                            Expiration Date
                                        </label>
                                        <input
                                            type="date"
                                            className="bg-light rounded-lg py-3 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0 placeholder:text-primary"
                                            id="expiration-date"
                                            placeholder=''
                                        />
                                    </div>
                                    {/* Submit Button */}
                                    <div className="col-span-1 sm:col-span-2">
                                        <button
                                            type="button"
                                            className="py-3 px-10 text-white bg-primary-900 rounded-lg transition duration-200 hover:bg-primary-800"
                                        >
                                            Add Card
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* // x---------------------------------x Card Setting Section // x---------------------------------x  */}
                <div className="lg:col-span-4">
                    <div className="h-full bg-transparent border-0">
                        <div className="flex justify-between p-3">
                            <h3 className="text-dark text-lg sm:text-2xl font-semibold">Card Setting</h3>
                        </div>
                        <div className="card-body bg-white rounded-lg p-4">
                            <div className="flex flex-col  h-full">
                                {CardSettingData.map((data, index) => (
                                    <div className="flex justify-between m-2" key={index}>
                                        <div className="flex gap-4">
                                            <div className={`card-img w-14 h-14 rounded-xl flex items-center justify-center  ${data.icon_Bg}`}>
                                                {data.icon}
                                            </div>
                                            <div>
                                                <p className="text-dark text-base font-medium m-0">{data.Heading}</p>
                                                <p className="text-muted text-sm font-normal m-0">{data.Description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* // x---------------------------------x Card Setting Pop Up // x---------------------------------x  */}
            <div className="relative z-50">
                {isOpen && (
                    <div
                        className="fixed px-2 top-0 inset-0 bg-gray-900 bg-opacity-50 flex items-start justify-center transition-opacity duration-300 ease-in-out py-10 overflow-scroll"
                        onClick={() => setIsOpen(false)}
                    >
                        <div
                            className={`bg-light1 text-dark py-4 rounded-lg shadow-lg relative w-full max-w-xs sm:max-w-md md:max-w-lg 
                            transform transition-all duration-300 ease-in-out 
                            ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className='modal_header mb-5 border-b pb-4 flex justify-between items-center' >
                                <div className="w-full p-4 text-dark">
                                    <h2 className="text-xl font-semibold">Card Details</h2>
                                </div>
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="px-4 py-2 mr-6 rounded"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="modal_body">
                                <div className="card">
                                    <div className="px-6">
                                        <div className="table-responsive overflow-x-scroll custom_scroll">
                                            <table className="w-full table-auto text-left text-sm text-dark">
                                                <tbody>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">Card Type:</td>
                                                        <td className="p-2">Credit Card</td>
                                                    </tr>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">Bank Name:</td>
                                                        <td className="p-2">Sample Bank</td>
                                                    </tr>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">Card Number:</td>
                                                        <td className="p-2">**** **** **** 1234</td>
                                                    </tr>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">Cardholder Name:</td>
                                                        <td className="p-2">John Doe</td>
                                                    </tr>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">Expiration Date:</td>
                                                        <td className="p-2">12/25</td>
                                                    </tr>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">CVV/CVC:</td>
                                                        <td className="p-2">***</td>
                                                    </tr>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">Billing Address:</td>
                                                        <td className="p-2">1234 Elm Street, Springfield, IL</td>
                                                    </tr>
                                                    <tr className="border-t border-gray-500">
                                                        <td className="p-2 font-medium text-dark opacity-70">Additional Information:</td>
                                                        <td className="p-2">Rewards Program: 2% Cashback</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )}
            </div>
        </>
    )
}

export default CreditCards